module.exports = __webpack_public_path__ + "static/16-b376981f8e294dda5faf715a3a9bc29f.png";